import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import "./Footer.css";
import { Container, Typography } from "@material-ui/core";
import bubble from "../../../Image/bubble.png";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    fontFamily: "Mulish, sans-serif !important",
    paddingTop: "30px",
  },
  paper: {
    padding: "10px 0",
    color: theme.palette.text.secondary,
    boxShadow: "none",
    fontSize: "1rem",
    color: "#2B2D33",
    fontWeight: " 800",
  },
  footerSubTitle: {
    fontSize: "1rem !important",
    cursor: "pointer",
    color: "#2B2D33",
  },
}));
/*


Blog */
const Footer = () => {
  const classes = useStyles();
  function FormRow() {
    return (
      <React.Fragment>
        <Grid item xs={6} sm={6} lg={3}>
          <Paper className={classes.paper}>ABC Group</Paper>
          <Typography
            variant="h6"
            className={classes.footerSubTitle}
            sx={{ cursor: "pointer" }}
          >
            All Rights Reserved (c) 2022
          </Typography>
        </Grid>
        <Grid item xs={6} sm={6} lg={3}>
          <Paper className={classes.paper}>Meet us</Paper>
          <Typography variant="h6" className={classes.footerSubTitle}>
            About
          </Typography>
          <Typography variant="h6" className={classes.footerSubTitle}>
            Terms & Conditions
          </Typography>
          <Typography variant="h6" className={classes.footerSubTitle}>
            Terms of service
          </Typography>
          <Typography variant="h6" className={classes.footerSubTitle}>
            Privacy policy
          </Typography>
        </Grid>
        <Grid item xs={6} sm={6} lg={2}>
          <Paper className={classes.paper}>Explore</Paper>
          <Typography variant="h6" className={classes.footerSubTitle}>
            Questions & Answers
          </Typography>
          <Typography variant="h6" className={classes.footerSubTitle}>
            Help point
          </Typography>
          <Typography variant="h6" className={classes.footerSubTitle}>
            Blog
          </Typography>
        </Grid>
        <Grid item xs={6} sm={6} lg={2}>
          <Paper className={classes.paper}>Contact</Paper>
          <Typography variant="h6" className={classes.footerSubTitle}>
            +971 3283439
          </Typography>
          <Typography variant="h6" className={classes.footerSubTitle}>
            info@abc.com
          </Typography>
        </Grid>
        <Grid item xs={6} sm={6} lg={2}>
          {/* <Paper className={classes.paper}></Paper> */}
          <img src={bubble} alt="bubble" />
        </Grid>
      </React.Fragment>
    );
  }
  return (
    <div className={classes.root}>
      <Container>
        <Grid container spacing={1}>
          <Grid container item xs={12} spacing={3}>
            <FormRow />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Footer;
